import React, { useState } from "react";
import { PriPPLWise } from "../../../Components/KPI/PriPPLWise";
import First from "../../../Artifacts/ILMCVT.png";
import Second from "../../../Artifacts/SCVPU.png";
import Third from "../../../Artifacts/HCV.png";
import Fourth from "../../../Artifacts/ILMCV.png";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import RetailpplModal from "../../../Components/Modals/RetailPplModal";

const fetchPPLWiseRetail = async (body) => {
  try {
    const res = await axInst.post("/retails/lob_wise_retail", body);
    return res.data.ppl_wise_retail;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const PPLWise = () => {
  const [selOps, setSelOps] = useState({ retail_status: ["Total Retail"] });
  const { data, submitted } = useSelector((e) => e.filters);
  const [modalData, setModalData] = useState(null);
  const [selectedOption, setSelectedOption] = useState("Total Retail");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: Data } = useQuery({
    queryKey: ["ppl", submitted, selOps.retail_status],
    queryFn: () => fetchPPLWiseRetail({ ...data, ...selOps }),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const getTotal = (obj) => Object.values(obj || {}).reduce((a, b) => a + b, 0);
  const formatItems = (obj) =>
    Object.entries(obj || {}).map(([label, value]) => ({
      label,
      value,
    }));

  const handleSelectionChange = (event) => {
    const selection = event.target.value;
    setSelOps({ retail_status: [selection] });
    setSelectedOption(selection);
  };

  const handleItemClick = (label, icon, alt, darkcolor, title) => {
    setModalData({
      lob: [label],
      selOps: selOps,
      clickedLabel: label,
      icon: icon,
      alt: alt,
      darkcolor: darkcolor,
      Product_Line: title,
      api: "/retails/ppl_wise_retail",
    });
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="grid grid-rows-[auto_1fr] p-2 pb-3 bg-white rounded-md relative">
        <section className="flex justify-between pb-2">
          <header className=" text-base font-semibold text-[#545454]">
            LOB Wise Retail
          </header>
          <div className="w-28 flex justify-end">
            <select
              value={selectedOption}
              onChange={handleSelectionChange}
              className="border border-gray-300 text-sm rounded-md h-6 w-28"
            >
              <option value="Total Retail">Total Retail</option>
              <option value="Todays Retail">Today's Retail</option>
            </select>
          </div>
        </section>

        <div className="grid gap-2 lg:grid lg:grid-cols-1 md:grid md:grid-cols-2 mt-2 relative">
          <PriPPLWise
            onItemClick={(label) =>
              handleItemClick(
                label,
                First, // icon
                "ILMCV Trucks", // alt
                "bg-[#08B7C3] text-[#A2EDF2]", // darkcolor
                "ILMCV Trucks", // title
              )
            }
            darkcolor={"bg-[#08B7C3] text-[#A2EDF2]"}
            color={"bg-[#A2EDF2]"}
            icon={First}
            alt={"ILMCV Trucks"}
            title={"ILMCV Trucks"}
            total={getTotal(Data?.["ILMCV Trucks"])}
            items={formatItems(Data?.["ILMCV Trucks"])}
          />

          <PriPPLWise
            onItemClick={(label) =>
              handleItemClick(
                label,
                Second,
                "SCV  & PU",
                "bg-[#4F81BA] text-[#DBECFF]",
                "SCV  & PU",
              )
            }
            darkcolor={"bg-[#4F81BA] text-[#DBECFF]"}
            color={"bg-[#DBECFF]"}
            icon={Second}
            alt={"SCV C & PU"}
            title={"SCV C & PU"}
            total={getTotal(Data?.["SCV & PU"])}
            items={formatItems(Data?.["SCV & PU"])}
          />
          <PriPPLWise
            onItemClick={(label) =>
              handleItemClick(
                label,
                Second,
                "HCV TRUCKS",
                "bg-[#ccad5e] text-[#fff3d4]",
                "HCV TRUCKS",
              )
            }
            darkcolor={"bg-[#ccad5e] text-[#fff3d4]"}
            color={"bg-[#fff3d4]"}
            icon={Third}
            alt={"HCV TRUCKS"}
            title={"HCV TRUCKS"}
            total={getTotal(Data?.["HCV Trucks"])}
            items={formatItems(Data?.["HCV Trucks"])}
          />
          <PriPPLWise
            onItemClick={(label) =>
              handleItemClick(
                label,
                Fourth,
                "CV Passengers",
                "bg-[#FF8E33] text-[#FFC699]",
                "CV Passengers",
              )
            }
            darkcolor={"bg-[#FF8E33] text-[#FFC699]"}
            color={"bg-[#FFC699]"}
            icon={Fourth}
            alt={"CV Passengers"}
            title={"CV Passengers"}
            total={getTotal(Data?.["CV Passenger"])}
            items={formatItems(Data?.["CV Passenger"])}
          />
        </div>

        {isModalOpen && (
          <RetailpplModal
            closeModal={() => setIsModalOpen(false)}
            modalData={modalData}
          />
        )}
      </div>
    </>
  );
};
